import React, { useState, useRef, useEffect } from "react";
import { RelatedArticleOptions, RelatedArticleResults } from ".";
import { useSelector } from "react-redux";
import { IconButton, Icon, Button } from "..";
import { useClickOutside, useKeyPress, useEventListener } from "../../_hooks";
import { searchArticles } from "../../_services";
//Define basic search/filter options
const defaultOptions = {
  typesFilter: [],
  excludeStubs: false,
  excludeWIP: false,
  excludeDrafts: false,
  excludePrivate: false,
};

export function RelatedArticleSearch({
  articleType,
  onCancel,
  onSelect,
  placeholder = "Search Articles",
}) {
  const { details: world } = useSelector((state) => state.world);
  const [searchTerm, setSearchTerm] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [options, setOptions] = useState(defaultOptions);
  const [results, setResults] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [cursorIndex, setCursorIndex] = useState(0);

  const componentRef = useRef();
  const inputRef = useRef();

  //TODO: Create a handler for onSelect, then we can hook in and clear pointer, results
  //TODO: Make sure the list isn't closed by selecting an article.

  const handleSearchChange = () => {
    if (inputRef.current) {
      setSearchTerm(inputRef.current.value);
    }
  };

  const toggleOptions = () => {
    setShowOptions((prev) => !prev);
  };

  const handleClear = (ev) => {
    setSearchTerm("");
    //...set results
    //...clear filters? (prolly no)
    if (onCancel) onCancel(ev);
    setCursorIndex(0);
  };

  useClickOutside(componentRef, () => {
    setShowOptions(false);
    // setCursorIndex(0);
    //...set results?
  });

  const handleOptionsChange = (change) => {
    setOptions((prev) => ({ ...prev, ...change }));
  };

  useEffect(() => {
    if (searchTerm && searchTerm.length > 2 && !isLoading) {
      setLoading(true);

      const query = searchTerm.toLocaleLowerCase();
      searchArticles(query, world.waID, options).then((articles) => {
        if (!Array.isArray(articles)) {
          console.log(`Converting "${articles}" into an array!`);
          articles = [];
        }
        setResults(articles);
        setLoading(false);
        setCursorIndex(0);
        console.log("Results: ", articles);
      });
    } else {
      setResults([]);
    }
  }, [searchTerm]);

  useEventListener("keydown", ({ key }) => {
    const keys = ["ArrowDown", "ArrowUp", "Enter"];
    if (keys.indexOf(key) === -1) {
      return;
    }

    switch (key) {
      case "ArrowDown":
        setCursorIndex((prev) => {
          if (prev >= results.length) {
            return 0;
          }
          return prev + 1;
        });
        break;
      case "ArrowUp":
        setCursorIndex((prev) => {
          if (prev <= 0) {
            return results.length - 1;
          }
          return prev - 1;
        });
        break;
      case "Enter":
        const chosenArticle = results[cursorIndex];
        if (chosenArticle) onSelect(chosenArticle);
        break;
    }
  });

  return (
    <div className="chronos-article-search-box" ref={componentRef}>
      <div className="article-search-control input-group">
        {!isLoading && (
          <IconButton
            iconOnly
            icon="far fa-times fa-fw"
            onClick={handleClear}
          />
        )}
        {isLoading && (
          <IconButton
            iconOnly
            icon="far fa-sync fa-fw fa-spin"
            style={{ cursor: "default" }}
          />
        )}

        <input
          type="text"
          value={searchTerm}
          className="form-control"
          onChange={handleSearchChange}
          placeholder={placeholder}
          ref={inputRef}
        />
        <div className="input-group-append">
          <Button
            color={showOptions ? "primary" : "secondary"}
            className={showOptions ? "chronos-dropdown-open" : ""}
            // className={'btn ' + showOptions ? 'btn-primary' : 'btn-secondary'}
            onClick={toggleOptions}
          >
            <Icon icon="far fa-cog fa-fw" />
          </Button>
        </div>
      </div>
      {showOptions && (
        <RelatedArticleOptions options={options} update={handleOptionsChange} />
      )}
      {searchTerm && searchTerm.length > 0 && (
        <RelatedArticleResults
          highlightedOption={cursorIndex}
          results={results}
          onSelect={onSelect}
          isLoading={isLoading}
        />
      )}
    </div>
  );
}
